import { useThemeColors } from '@/hooks/useThemeColors';
import { ArrowLeft, X } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ClassLayoutProps {
    children: React.ReactNode;
    courseTitle?: string;
    courseSlug?: string;
    backUrl?: string;
    onClose?: () => void;
}

const ClassLayout: React.FC<ClassLayoutProps> = ({
    children,
    courseTitle,
    courseSlug,
    backUrl,
    onClose,
}) => {
    const { t } = useTranslation();
    const colors = useThemeColors();

    const handleGoBack = () => {
        if (onClose) {
            onClose();
        } else if (backUrl) {
            window.location.href = backUrl;
        } else if (courseSlug) {
            window.location.href = `/courses/${courseSlug}`;
        } else {
            window.history.back();
        }
    };

    return (
        <div className="min-h-screen bg-gray-900 text-white">
            {/* Minimal Header */}
            <header className="bg-opacity-50 border-b border-gray-800 bg-black backdrop-blur-sm">
                <div className="flex max-w-full items-center justify-between px-4 py-3">
                    {/* Left Section - Back Button */}
                    <div className="flex items-center space-x-4">
                        <button
                            onClick={handleGoBack}
                            className="flex items-center space-x-2 text-gray-300 transition-colors duration-200 hover:cursor-pointer hover:text-white"
                        >
                            <ArrowLeft size={20} />
                            <span className="hidden text-sm font-medium sm:inline">
                                {t('course.backToDashboard')}
                            </span>
                        </button>

                        {courseTitle && (
                            <>
                                <div className="hidden h-6 w-px bg-gray-600 md:block"></div>
                                <div className="hidden md:block">
                                    <h1 className="max-w-xs truncate text-sm font-medium text-gray-300">
                                        {courseTitle}
                                    </h1>
                                </div>
                            </>
                        )}
                    </div>

                    {/* Right Section - Close Button */}
                    <button
                        onClick={handleGoBack}
                        className="hover:bg-opacity-10 rounded-lg p-2 text-gray-400 transition-all duration-200 hover:cursor-pointer hover:bg-gray-700 hover:text-white"
                        title={t('course.close')}
                    >
                        <X size={20} />
                    </button>
                </div>
            </header>

            {/* Main Content */}
            <main className="flex-1">{children}</main>
        </div>
    );
};

export default ClassLayout;
